import styled from 'styled-components';

export const Main = styled.div`
  .cus-table thead th {
    background-color: #1976d2 !important;
    color: white;
    border: 1px solid black;
    height: 40px;
  }

  .cus-table-x tbody td {
    border: 1px solid black;
    height: 40px;
    padding-left: 10px;
  }
  .text-center {
    text-align: center;
  }
  span.title.moveMouse.active-tab {
    font-weight: 700;
  }
`;
